<template>
  <widget-content :class="isMobile ? 'image_text_mobile' : 'image_text_desk'" :is-disabled="$store.getters.isStandAloneMode" :bg="model.background" :mobile-bg="model.mobileBackground">
    <module-block :bg="model.background" :mobile-bg="model.mobileBackground" :max-content-width="1280">
      <div class="imageText-content">
        <div class="back-color-wrap" :style="backColorStyle" />
        <rich-text
          v-if="model.titleVisible"
          v-model="model.title"
          :editing="editing"
          :family.sync="model.titleFamily"
          :stroke.sync="model.titleStroke"
          :disabled="!editing"
          theme="snow"
          class="image_text_title relative"
          placement="bottom"
        />
        <div ref="imageTextItem" :class="['image_text_warp flex flex-col', { 'image_text_empty': !(model.children && model.children.length) }]">
          <div v-for="(child, index) in children" :key="index" :class="['image_text_warp_row', {'justify-center': !isMobile && model.alignMethod === 'center'}]">
            <div v-for="(block, idx) in child" :key="block.id" class="flex items-center justify-center image_text_warp_row_item">
              <model-wrapper class="w-full h-full" :model="block" :parent-model="model" :model-index="idx">
                <image-text-item
                  :child-index="idx"
                  :site="site"
                  :is-mobile="isMobile"
                  :model="model"
                  :editing="editing"
                  :target="block"
                  class="w-full h-full"
                />
              </model-wrapper>
            </div>
          </div>
        </div>
      </div>
    </module-block>
  </widget-content>
</template>

<script>
import chunk from 'lodash.chunk'
import ImageTextItem from './item.vue'
import ModelWrapper from '~/components/modelWrapper/index.vue'
import RichText from "~/components/richText";
import WidgetContent from '~/site/components/widgetContent'
import ModuleBlock from '~/components/common/ModuleBlock.vue'

export default {
  name: "ImageTextWidget",
  components: {
    ModuleBlock,
    ModelWrapper,
    ImageTextItem,
    RichText,
    WidgetContent,
  },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
    site: {
      type: Object,
      default: () => { }
    },
    model: {
      type: Object,
      default() {
        return {}
      }
    },
    device: {
      type: String,
      default: 'desktop'
    }
  },
  computed: {
    backColorStyle() {
      if (this.model?.backgroundColorShow) {
        return this.model.backgroundColor
      }
      return {}
    },
    showTitle() {
      return this.model.imageTextTitleShow
    },
    children() {
      return chunk(this.model.children, 3) || []
    },
    isMobile() {
      return this.device === 'mobile'
    },
  }
}
</script>

<style lang="less" scoped>
.image_text_desk {
  padding: 20px 0;
  .image_text_title {
    letter-spacing: 0;
    margin-bottom: 46px;
  }

  .image_text_warp {
    row-gap: 32px;
    .image_text_warp_row {
      display: flex;
      column-gap: 32px;
      .image_text_warp_row_item {
        width: calc((100% - 64px) / 3);
      }
    }
  }
}

.image_text_mobile {
  padding: 10px;
  .module-block.is-moble {
    padding: 10px 16px;
  }
  .image_text_title {
    line-height: 36px;
    letter-spacing: 0;
    margin-bottom: 16px;
  }

  .image_text_warp {
    .image_text_warp_row {
      display: flex;
      flex-direction: column;
      .image_text_warp_row_item {
        width: 100%;
        &:not(:last-child) {
          margin-bottom: 28px;
        }
      }
      &:not(:last-child) {
        margin-bottom: 28px;
      }
    }
  }
}

.image_text_empty {
  min-height: auto;
  padding: 0 48px;
}
</style>
